package com.karyadina.di


import com.karyadina.service.PomodoroServiceImpl
import com.karyadina.service.PomodoroStorage
import com.karyadina.service.PomodoroStorageImpl
import com.karyadina.service.SessionTimerManager
import com.karyadina.service.StudyPlannerServiceImpl
import com.karyadina.service.TaskService
import com.karyadina.service.TaskServiceImpl
import com.karyadina.service.createTimerNotificationService
import com.karyadina.service.FlashcardService
import com.karyadina.service.FlashcardServiceImpl
import com.karyadina.service.FlashcardStorage
import com.karyadina.service.FlashcardStorageImpl

import com.karyadina.service.TaskStorage
import io.ktor.client.HttpClient
import io.ktor.client.plugins.HttpTimeout
import io.ktor.client.plugins.logging.LogLevel
import io.ktor.client.plugins.logging.Logging
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.serialization.kotlinx.json.json
import com.karyadina.ui.screens.TaskTrackerViewModel
import com.karyadina.ui.navigation.MainViewModel
import com.karyadina.ui.screens.pomodorotimer.presentation.PromodorTimerViewModel
// import com.karyadina.ui.viewmodels.AssistantViewModel  // ⚠️ DISABLED: Requires Agent feature

// IAP Service imports


import org.koin.core.module.dsl.singleOf
import org.koin.core.module.dsl.viewModel
import org.koin.core.module.dsl.viewModelOf // If using Koin 3.5+
import org.koin.dsl.module
import org.koin.dsl.bind

val appModule = module {
    // 1. SINGLE: Creates one instance for the whole app life (Singleton)
    // Equivalent to: single { PomodoroServiceImpl() }
    
    // Include Free Source module
    includes(com.karyadina.freesource.di.freeSourceModule)

    single<PomodoroStorage> { PomodoroStorageImpl() }
    singleOf(::PomodoroServiceImpl)

    single<com.karyadina.service.KeyValueStorage> { com.karyadina.service.AppStorage.get() }

    // Task Tracker
    single { TaskStorage(get()) }
    single<TaskService> { TaskServiceImpl(get()) }
    
    // Flashcard Service
    single<FlashcardStorage> { FlashcardStorageImpl(get()) }
    single<FlashcardService> { FlashcardServiceImpl(get()) }
    
    // Subscription Service (multiplatform - web uses stub, Android uses real)
    single<com.karyadina.service.SubscriptionService> { provideSubscriptionService(get()) }
    // Purchase Handler (multiplatform - web uses stub, Android uses real)
    single<com.karyadina.service.PurchaseHandler> { 
        providePurchaseHandler(get<com.karyadina.service.SubscriptionService>(), get<HttpClient>())
    }


    // 2. FACTORY/VIEWMODEL: Creates a new instance every time the screen is shown
    // This automatically finds the Service above and injects it into the ViewModel
    factory { PromodorTimerViewModel(get()) }
    viewModelOf(::TaskTrackerViewModel)
    viewModelOf(::MainViewModel)

    // viewModel { AssistantViewModel(get()) }  // ⚠️ DISABLED: Requires Agent feature
    
    // 3. CORE SERVICES
    single { provideSettings() }
    single { StudyPlannerServiceImpl() }
    single { SessionTimerManager(get(), get()) }
    single { createTimerNotificationService(get()) }
    single { com.karyadina.service.provideModelManager() } // Model Manager
    single<com.karyadina.service.QuickNotesService> { com.karyadina.service.QuickNotesServiceImpl() }
    single { com.karyadina.ui.AppLocaleManager(get(), get()) }
    
    // HTTP Client for network requests
    single {
        HttpClient {
            install(ContentNegotiation) {
                json()
            }
            install(Logging) {
                level = LogLevel.NONE  // No HTTP request/response logging
            }
            install(HttpTimeout) {
                requestTimeoutMillis = 10000
                socketTimeoutMillis = 10000
            }
        }
    }
    
    ocrServiceDefinition()
    translationServiceDefinition()
    
    /* ========================================
       AGENT COMPONENTS - DISABLED (ENABLE_AGENT = false)
       To re-enable agent, set ENABLE_AGENT = true at the top of this file
       ======================================== */
    
    /*
    single { com.karyadina.agent.tools.LanguageControlTool(get(), get()) }
    single { com.karyadina.agent.tools.SettingsTool(get()) }
    
    single { com.karyadina.agent.tools.ReadNotesTool(get()) }
    single { com.karyadina.agent.tools.CreateNoteTool(get()) }
    single { com.karyadina.agent.tools.AppendToNoteTool(get()) }
    single { com.karyadina.agent.tools.ApplyTagsTool(get()) }
    single { com.karyadina.agent.tools.CreateChecklistTool(get()) }
    single { com.karyadina.agent.tools.NavigationTool(get()) }
    
    // Provide LIST of tools
    single { 
        listOf<com.karyadina.agent.AgentTool>(
            get<com.karyadina.agent.tools.LanguageControlTool>(),
            get<com.karyadina.agent.tools.SettingsTool>(),
            get<com.karyadina.agent.tools.ReadNotesTool>(),
            get<com.karyadina.agent.tools.CreateNoteTool>(),
            get<com.karyadina.agent.tools.AppendToNoteTool>(),
            get<com.karyadina.agent.tools.ApplyTagsTool>(),
            get<com.karyadina.agent.tools.CreateChecklistTool>(),
            get<com.karyadina.agent.tools.NavigationTool>()
        ) 
    }
    
    // Mock Agent
    single<com.karyadina.agent.AppAgent>(org.koin.core.qualifier.named("mock")) {
        com.karyadina.agent.MockGeminiAgent(
            get<com.karyadina.agent.tools.LanguageControlTool>(),
            get<com.karyadina.agent.tools.SettingsTool>(),
            get<com.karyadina.agent.tools.NavigationTool>(),
            get<com.karyadina.agent.tools.CreateNoteTool>(),
            get<com.karyadina.agent.tools.ReadNotesTool>()
        )
    }
    
    // Real Agent (Factory because API Key might change)
    factory<com.karyadina.agent.AppAgent>(org.koin.core.qualifier.named("real")) { (apiKey: String) ->
        com.karyadina.agent.GeminiRemoteAgent(apiKey, get(), get())
    }
    
    // Default AppAgent - Smart Proxy
    single<com.karyadina.agent.AppAgent> { 
        com.karyadina.agent.SmartAgentProxy(
            mockAgent = get(org.koin.core.qualifier.named("mock")),
            realAgentFactory = { key -> get(org.koin.core.qualifier.named("real")) { org.koin.core.parameter.parametersOf(key) } },
            storage = get()
        )
    }
    */
}